module.exports = __webpack_public_path__ + "img/fun5.2dc95e4b.png";